export const clpConfigResponse = {
    response: {
        model: {
            JsessionId: "yyG6_RaRI30WfYRNXaPtRSE4PmWerPzboE2dmzHU!1662386062613",
            configToken: "eyJhbGciOiJIUzI1NiJ9.eyJVTV9ESVNQTEFZX0ZPUkNFU0lHTiI6InRydWUiLCJVTV9ERVRFQ1RfTEFORyI6InRydWUiLCJVTV9QV0RfRVhQX05CREFZUyI6IjUiLCJVTV9MQU5HX0JPWF9GTEFHIjoiZmFsc2UiLCJVTV9ERUZBVUxUX0RVVFlfQ09ERSI6IiIsIlVNX0FQUExJQ0FUSU9OX0lEIjoiQVNXIiwiVU1fRElTUExBWV9SRU1fTUUiOiJ0cnVlIiwiVU1fTE9HSU5fTEFOR19CT1giOiJ0cnVlIiwiVU1fTUFJTF9GUk9NIjoiXFxcIkFtYWRldXMgU2VjdXJpdHkgU2VydmljZVxcXCI8bm9yZXBseUBhbWFkZXVzLmNvbT4iLCJVTV9ESVNQTEFZX0RVVFlfQ09ERSI6InRydWUiLCJVTV9MU1NfT1JHQU5JU0FUSU9OIjoiMUEiLCJVTV9PRkZJQ0VfTkVFREVEIjoidHJ1ZSIsIlVNX1BXRF9FWFBfV0FSTiI6InRydWUifQ.nREHp3MS22J3Pi4HPP6Q6uDwSF3YtRmtiZn1V40IC-w",
            nonce: "Y2okzkHeoegzzRm-",
            baseUrl: "https://pdt.accounts.amadeus.com"
        }
    }
};

export const clpLoginResponse = {
    accessToken: "eyJhbGciOiJIUzI1NiJ9",
    idToken: "eyJhbGciOiJIUzI1NiJ9",
    nonce: "Y2okzkHeoegzzRm"
}


export const envConfigModelResponse = {
    response: {
        model: {
            AD_IS_PROD: 'TRUE'.toLowerCase() === 'true',
            AD_MAGENTO_URL: 'https://api.uat.amadeus-direct.com/',
            AD_GOOGLE_TAG_ID: 'GTM-T2CN8HH',
            AD_JAVA_API_URL: 'https://ws.uat.amadeus-direct.com/',
            AD_ALP_URL: 'https://uat-b2b.amadeusleisureplatform.com',
            API: {
                registration: {
                    profiles: 'rest/all/V1/amadeus/private/registration',
                    eloqua: 'https://s266319173.t.eloqua.com/e/f2',
                    configs: '/V1/amadeus/public/modularity/config',
                    menu: '/V1/amadeus/public/menu/list',
                    agreement: '/V1/amadeus/public/cms_page/registration-agreement'
                },
                sso: {
                    training: 'https://servicehub.amadeus.com',
                    trainingItaly: 'https://servicehub.it.amadeus.com/login.aspx',
                    liveTravel: 'https://live-travel.community.amadeus.com/?_58_redirect=/web/community',
                    ssoEncrypted: 'api/amadeus/encryptedSSOParams',
                    ssoLoyalty: 'api/amadeus/loyalty/link/'
                }
            }
        }
    }
};

export const envConfigResponse = {
    AD_IS_PROD: true,
    AD_MAGENTO_URL: 'https://api.uat.amadeus-direct.com/',
	AD_JAVA_API_URL: 'https://ws.uat.amadeus-direct.com/',
	AD_GOOGLE_TAG_ID: 'GTM-T2CN8HH',
	AD_ALP_URL: 'https://uat-b2b.amadeusleisureplatform.com',
    API: {
        registration: {
            profiles: 'rest/all/V1/amadeus/private/registration',
            eloqua: 'https://s266319173.t.eloqua.com/e/f2',
            configs: '/V1/amadeus/public/modularity/config',
            menu: '/V1/amadeus/public/menu/list',
            agreement: '/V1/amadeus/public/cms_page/registration-agreement'
        },
        SSO: {
            training: 'https://servicehub.amadeus.com',
            trainingItaly: 'https://servicehub.it.amadeus.com/login.aspx',
            liveTravel: 'https://live-travel.community.amadeus.com/?_58_redirect=/web/community',
            ssoEncrypted: 'api/amadeus/encryptedSSOParams',
            ssoLoyalty: 'api/amadeus/loyalty/link/'
        }
    }
};
